import { cn } from '@costar-ui/cosmos';
import React__default from 'react';

var ContactName = function ContactName(_ref) {
  var firstName = _ref.firstName,
    lastName = _ref.lastName,
    className = _ref.className;
  return /*#__PURE__*/React__default.createElement("h3", {
    "automation-id": "contact-".concat(firstName, "-").concat(lastName),
    className: cn('flex flex-row flex-wrap whitespace-pre-wrap break-normal font-sans text-p-18/[22.5px] font-bold', className)
  }, "".concat(firstName, " ").concat(lastName));
};

export { ContactName };
//# sourceMappingURL=contact-name.esm.js.map
